module.exports = __webpack_public_path__ + "img/b-yellow-l@2x.0d65df19.png";